import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { TaskExecution, PaginatedTaskExecutionResponse } from "./models";

export const taskHubExecutionApi = createApi({
  baseQuery,
  reducerPath: "taskHubApiExecution",
  tagTypes: ["Tasks-Execution"],
  endpoints: (builder) => ({
    getTasksExecution: builder.query<TaskExecution[], any>({
      query: (params) => ({
        url: "/api/v1/taskexecutions/",
        method: "GET",
        params,
      }),
      transformResponse: (
        response: TaskExecution[] | PaginatedTaskExecutionResponse
      ) => {
        if (Array.isArray(response)) {
          return response;
        }
        return response.results || [];
      },
      providesTags: (_result, _error) => [
        { type: "Tasks-Execution", id: "LIST" },
      ],
    }),
    updateTaskExecution: builder.mutation<
      TaskExecution,
      { id: number; data: Partial<TaskExecution> }
    >({
      query: ({ id, data }) => ({
        url: `/api/v1/taskexecutions/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Tasks-Execution", id: "LIST" },
        { type: "Tasks-Execution", id },
      ],
    }),
    createTaskExecution: builder.mutation<
      TaskExecution,
      Partial<TaskExecution>
    >({
      query: (data) => ({
        url: `/api/v1/taskexecutions/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "Tasks-Execution", id: "LIST" }],
    }),
  }),
});

export const {
  useGetTasksExecutionQuery,
  useUpdateTaskExecutionMutation,
  useCreateTaskExecutionMutation,
} = taskHubExecutionApi;
